import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getVoiceSettings,
  patchVoiceSettings,
  previewVoiceAssistant,
  syncVoiceAssistant,
} from "../api/voiceSettings";
import type { PatchVoiceSettingsRequest } from "../api/voiceSettings";
import { useVoiceSettingsStore } from "../store/voiceSettingsSlice";

export const voiceSettingsQueryKey = (businessId: string | null) => [
  "voiceSettings",
  businessId,
];

export function useVoiceSettings(businessId: string | null) {
  return useQuery({
    queryKey: voiceSettingsQueryKey(businessId),
    queryFn: () => getVoiceSettings(businessId!),
    enabled: !!businessId,
    staleTime: 60_000,
  });
}

export function usePatchVoiceSettings(businessId: string | null) {
  const qc = useQueryClient();
  const { resetDraft } = useVoiceSettingsStore();

  return useMutation({
    mutationFn: (payload: PatchVoiceSettingsRequest) =>
      patchVoiceSettings(businessId!, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: voiceSettingsQueryKey(businessId) });
      resetDraft();
    },
  });
}

export function usePreviewVoiceAssistant(businessId: string | null) {
  return useMutation({
    mutationFn: () => previewVoiceAssistant(businessId!),
  });
}

export function useSyncVoiceAssistant(businessId: string | null) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: () => syncVoiceAssistant(businessId!),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: voiceSettingsQueryKey(businessId) });
    },
  });
}
